import {
  Box,
  Divider,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useMemo, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // import first
import PageContainer from "src/components/container/PageContainer";
// components
import { axisClasses, BarChart } from "@mui/x-charts";
import moment from "moment";
import { TailSpin } from "react-loader-spinner";
import { adminAxiosInstance } from "src/api/axios";
import utils from "src/assets/utils/utils";
import AdminFilterBox from "./AdminFilterBox";
import CSVButton from "./components/CSVButton";

const AdminDashboard = () => {
  const [user, setUser] = useState({});
  const [product, setProduct] = useState([]);
  const [parsedPayout, setParsedPayout] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  const lgDown = useMediaQuery((theme) => theme.breakpoints.down("lg"));

  //Bar Charts
  const [filter, setFilter] = useState("");
  const [firstDateFilter, setfirstDateFilter] = useState(moment());
  const [secondDateFilter, setsecondDateFilter] = useState(
    moment().add(-1, "month")
  );

  // useMemo(() => {
  //   if (!loaded) {
  //     adminAxiosInstance.get('/users').then((response) => {
  //       if ('status' in response && response.status === 200) {
  //         console.log(response.data);
  //         if (!response.data.isPhoneVerified && !response.data.isEmailVerified) {
  //           alert(
  //             'Your OTP has not been verified, Please register again , or login from a different account',
  //           );
  //           localStorage.removeItem('token');
  //           localStorage.removeItem('store');
  //           window.location.href = '/auth/register';
  //         }
  //         if (!response.data.gender || !response.data.dob) {
  //           window.location.href = '/auth/onboarding';
  //         }
  //         setUser(response.data);
  //         // setLoaded(true);
  //       }
  //     });
  //   }
  // }, []);

  const getDetails = () => {
    setLoaded(true);
    adminAxiosInstance
      .get(
        `/product/campaign?dateStart=${firstDateFilter}&dateEnd=${secondDateFilter}`
      )
      .then((response) => {
        if ("status" in response && response.status === 200) {
          console.log(response.data);
          const sortedObjects = response.data.sort((a, b) => {
            // Prioritize incomplete objects first
            if (a.incomplete !== b.incomplete) {
              return b.incomplete - a.incomplete;
            }

            // If incomplete count is equal, compare completed count in descending order
            return b.completed - a.completed;
          });

          setProduct(sortedObjects);
          setLoaded(false);
        }
      });
  };
  useMemo(() => {
    getDetails();
  }, []);

  const valueFormatter = (value) => `${value}`;

  const filterInputs = [
    {
      type: "text",
      name: "Campaign Name",
      state: filter,
      setState: setFilter,
      function: () => {},
    },
    {
      type: "date",
      dateEnd: secondDateFilter,
      dateStart: firstDateFilter,
      setDateEnd: setsecondDateFilter,
      setDateStart: setfirstDateFilter,
      function: getDetails,
    },
  ];
  return (
    <PageContainer
      title="Dashboard | EarnPati"
      description="this is Earnpati Admin Dashboard"
      sx={{ maxWidth: { xs: "100vw", lg: "70vw" } }}
    >
      <Grid container spacing={1} sx={{ padding: "0 .5rem" }}>
        <Grid item xs={12} spacing={3}>
          <>
            <Typography variant="h3" sx={{ my: 1 }}>
              Product Performance
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <AdminFilterBox
                inputs={filterInputs}
                submitFunction={getDetails}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                my: 1,
              }}
            >
              <Stack
                direction="row"
                justifyContent={"space-between"}
                sx={{ width: "100%" }}
              >
                <p>
                  Showing data of past:{" "}
                  {parseInt(
                    moment
                      .duration(firstDateFilter - secondDateFilter)
                      .asDays() || 0
                  )}{" "}
                  days
                </p>
                <CSVButton
                  csvData={product}
                  filename={`campaign_performance_${filter}_${new Date().toDateString()}.csv`}
                  direct={true}
                />
              </Stack>
            </Box>
            <Divider sx={{ my: 1 }} />
            <Box sx={{ maxWidth: "90vw", overflowX: "auto" }}>
              {product && product.length && !loaded ? (
                <BarChart
                  grid={true}
                  dataset={
                    filter
                      ? product.filter((i) =>
                          utils
                            .generate_regex(filter)
                            .test(i.campaign.toLowerCase())
                        )
                      : product
                  }
                  xAxis={[
                    {
                      scaleType: "band",
                      dataKey: "campaign",
                      valueFormatter: (campaign, context) => {
                        if (context.location === "tick") {
                          return `${campaign.trim().replaceAll(" ", "\n\r")} `;
                        } else if (context.location === "tooltip") {
                          return `${campaign}, \r\n${
                            product.filter((i) => i.campaign === campaign)[0]
                              ?.publisher
                          }`;
                        } else {
                          return `${campaign}`;
                        }
                      },
                    },
                  ]}
                  margin={{ top: 50, right: 5, bottom: 90, left: 70 }}
                  series={[
                    {
                      dataKey: "incomplete",
                      label: "incomplete",
                      valueFormatter,
                      color: "#0D47A1",
                    },
                    {
                      dataKey: "completed",
                      label: "completed",
                      valueFormatter,
                      color: "#008000",
                    },
                    {
                      dataKey: "pending",
                      label: "pending",
                      valueFormatter,
                      color: "#A17802",
                    },
                  ]}
                  width={
                    110 *
                    (filter
                      ? product.filter((i) =>
                          utils
                            .generate_regex(filter)
                            .test(i.campaign.toLowerCase())
                        ).length + 3
                      : product.length + 3)
                  }
                  height={450}
                  slotProps={{
                    legend: {
                      position: {
                        vertical: "top",
                        horizontal: "left",
                      },
                      direction: "row",
                      itemGap: 5,
                    },
                    margin: {
                      top: 20,
                      right: 100,
                    },
                    // Custom loading message
                    loadingOverlay: {
                      message: "Data should be available soon.",
                    },
                    // Custom message for empty chart
                    noDataOverlay: { message: "Select some data to display." },
                  }}
                  yAxis={[
                    {
                      label: "Leads Count",
                    },
                  ]}
                  sx={{
                    [`.${axisClasses.left} .${axisClasses.label}`]: {
                      transform: "translateX(-30px)",
                    },
                    width: "10px",
                  }}
                  borderRadius={10}
                />
              ) : (
                <Grid container>
                  <Grid item xs={12}>
                    <Stack
                      justifyContent={"center"}
                      alignItems={"center"}
                      height={"60vh"}
                    >
                      <TailSpin
                        height={45}
                        width={45}
                        style={{ margin: "auto", bg: "#444" }}
                      />
                    </Stack>
                  </Grid>
                </Grid>
              )}
            </Box>
          </>
        </Grid>
      </Grid>
      <ToastContainer />
    </PageContainer>
  );
};

export default AdminDashboard;